<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { ArrowRight } from 'lucide-vue-next';
import { register } from '@/routes';
</script>

<template>
    <section class="py-20">
        <div class="mx-auto max-w-5xl px-4">
            <div
                class="relative overflow-hidden rounded-3xl border border-brand/20 bg-gradient-to-br from-brand/[0.06] via-transparent to-brand/[0.03] px-8 py-16 text-center sm:px-16"
            >
                <!-- Subtle glow -->
                <div
                    class="pointer-events-none absolute top-0 left-1/2 h-40 w-80 -translate-x-1/2 rounded-full bg-brand/[0.08] blur-3xl"
                ></div>

                <div class="relative">
                    <h2
                        class="text-2xl font-semibold tracking-tight text-foreground sm:text-3xl"
                    >
                        Prêt à structurer votre revue de littérature ?
                    </h2>
                    <p
                        class="mx-auto mt-4 max-w-lg text-base text-muted-foreground"
                    >
                        Créez votre compte en 30 secondes. Pas de carte
                        bancaire, pas d'engagement. Commencez à importer vos
                        références aujourd'hui.
                    </p>

                    <div
                        class="mt-8 flex flex-wrap items-center justify-center gap-4"
                    >
                        <Link
                            :href="register()"
                            class="inline-flex items-center gap-2 rounded-full bg-brand px-7 py-3 text-sm font-medium text-white transition-all hover:bg-brand/85"
                        >
                            Commencer gratuitement
                            <ArrowRight class="h-4 w-4" />
                        </Link>
                        <a
                            href="#pricing"
                            class="inline-flex items-center rounded-full border border-border/60 px-7 py-3 text-sm font-medium text-foreground transition-colors hover:bg-accent/60"
                        >
                            Voir les tarifs
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
